import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { gatePassApi } from 'api';
import { GATEPASS_STATUS } from 'constants/gatepass';

const GatePassSubmitButton = ({
  gatePassId,
  currentStatus,
  onSuccess,
  disabled,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await gatePassApi.submit(gatePassId);
      toast.success('GatePass submitted successfully!');
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      toast.error('Failed to submit GatePass.');
    } finally {
      setIsLoading(false);
    }
  };

  if (currentStatus !== GATEPASS_STATUS.CREATED) {
    return null;
  }

  return (
    <Button
      variant="success"
      size="sm"
      onClick={handleSubmit}
      disabled={isLoading || disabled}
    >
      {isLoading ? 'Submitting...' : 'Submit GatePass'}
    </Button>
  );
};

GatePassSubmitButton.propTypes = {
  gatePassId: PropTypes.number.isRequired,
  currentStatus: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  disabled: PropTypes.bool,
};

export default GatePassSubmitButton;
